/** Possible error codes returned by Place */
export var PlaceErrorCodes;
(function (PlaceErrorCodes) {
    PlaceErrorCodes[PlaceErrorCodes["PARSE_ERROR"] = 0] = "PARSE_ERROR";
    PlaceErrorCodes[PlaceErrorCodes["BAD_REQUEST"] = 1] = "BAD_REQUEST";
    PlaceErrorCodes[PlaceErrorCodes["ACCESS_DENIED"] = 2] = "ACCESS_DENIED";
    PlaceErrorCodes[PlaceErrorCodes["REQUEST_FAILED"] = 3] = "REQUEST_FAILED";
    PlaceErrorCodes[PlaceErrorCodes["UNKNOWN_CMD"] = 4] = "UNKNOWN_CMD";
    PlaceErrorCodes[PlaceErrorCodes["SYS_NOT_FOUND"] = 5] = "SYS_NOT_FOUND";
    PlaceErrorCodes[PlaceErrorCodes["MOD_NOT_FOUND"] = 6] = "MOD_NOT_FOUND";
    PlaceErrorCodes[PlaceErrorCodes["UNEXPECTED_FAILURE"] = 7] = "UNEXPECTED_FAILURE";
})(PlaceErrorCodes || (PlaceErrorCodes = {}));
/** Logging levels of debug messages */
export var PlaceLogLevel;
(function (PlaceLogLevel) {
    PlaceLogLevel["Info"] = "info";
    PlaceLogLevel["Debug"] = "debug";
    PlaceLogLevel["Warning"] = "warn";
    PlaceLogLevel["Error"] = "error";
    PlaceLogLevel["Fatal"] = "fatal";
    PlaceLogLevel["Trace"] = "trace";
})(PlaceLogLevel || (PlaceLogLevel = {}));
